<template id="reset-password-modal-template">
  <form class="flex flex-col" @submit.prevent="beforeSend" id="reset-password-modal">
    <div class="modal-title">
      Ik ben mijn wachtwoord vergeten
    </div>
    <div class="modal-body">
        <p>
          Als je je AMA-wachtwoord bent vergeten, kun je het opnieuw instellen om weer te kunnen inloggen.
        </p>
        <p class="mt-1">
          Om dit te doen, voert u het e-mailadres in dat aan uw account is toegewezen,
          en klik vervolgens op de knop "Wachtwoord opnieuw instellen".
        </p>
        <p class="mt-1">
          U ontvangt onmiddellijk een e-mail met instructies voor het instellen van een nieuw wachtwoord.
        </p>
        <div class="mt-6">
            <label for="text-input-12" class="form-label">Email:</label>
            <input 
              id="text-input-12"
              type="email"
              name="email"
              v-model="email"
              v-validate="'required'"
              data-vv-as="Email"
              autocapitalize="off"
              class="form-input"
              :class="{ 'error': errors.has('email') }">
            <span class="block form-error" v-if="errors">{{ errors.first('email') }}</span>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-tertiary btn-sm" @click="close">Cancel</button>
        <button type="submit" class="btn btn-primary btn-sm">Wachtwoord opnieuw instellen</button>
    </div>
  </form>
</template>

<script>
import ApiService from '@/common/api.service';

import { mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
  name: 'ResetPasswordModal',
  template: '#reset-password-modal-template',
  props: ['show'],
  data() {
    return {
      email: ''
    };
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL
    }),
    close: function() {
      this.email = '';
      this.$validator.reset();
      this.hide();
    },
    beforeSend: function() {
      this.$validator.validateAll().then(result => {
        if (result) this.save();
      });
    },
    async save() {
      try {
        await ApiService.post('/v1/users/password-reset/request', {
          email: this.email
        });
        this.close();
      } catch (error) {
        this.errors = error.data.detail;
      }
    }
  }
};
</script>
